import styled from 'styled-components';

interface MentionContainerProps {
  backgroundColor?: string;
  color?: string;
}

export const MentionContainer = styled.span<MentionContainerProps>`
  display: inline-flex;
  vertical-align: middle;
  padding: 2px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
  cursor: pointer;

  .identifierWrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;

    .identifierIconWrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      overflow: hidden;
    }

    .identifier {
      text-decoration: none;
      font-size: 12px;
      font-weight: 600;
      line-height: 18px;
      color: ${({ color }) => color || '#1976d2'};
    }
  }

  &:hover {
    background-color: ${({ backgroundColor }) => backgroundColor ? `${backgroundColor}26` : '#bbdefb'};
    color: ${({ color }) => color ? color : '#0d47a1'};
  }
`;

export const ContainerTooltip = styled.div`
  width: 275px;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 6px;

    .topLeft {
      display: flex;
      flex-direction: column;
      gap: 6px;

      .topLeftIdentifier {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 6px;

        .identifier {
          font-size: 12px;
          font-weight: 600;
          line-height: 16px;
          color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
        }

        .type {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
        }
      }

      .topLeftIdentifierTitle {
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.surface.onSurface};
      }

      .topLeftDueDate {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;

        .cardDateText {
          font-size: 12px;
          font-weight: 600;
          line-height: 16px;
          color: ${({ theme }) => theme.colors.surface.onSurface};
        }

        .cardDateTextExpired {
          color: ${({ theme }) => theme.colors.danger.danger};
        }
      }
    }
    
    .img {
      width: 60px;
      height: 60px;
      border-radius: 4px;
      border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    }
  }

  .bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .bottomLeft {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 6px;

      .dividerWrapper {
        width: 1px;
        height: 24px;
        padding-top: 4px;
        padding-bottom: 4px;
        margin-left: 8px;

        .divider {
          width: 1px;
          height: 100%;
          background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
        }
      }

      .cardDisciplinesWrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;

        .cardDiscipline {
          
          .cardDisciplineIcon {
            color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
          }
        }

        .cardDisciplineText {
          font-size: 10px;
          font-weight: 600;
          line-height: 16px;
          color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
        }
      }
    }

    .bottomRight {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 2px;
    }
  }
`;
